import { onBeforeUnmount, ref } from 'vue';

/** Copy text and flip a flag for a moment, so the button can say "copied". */
export function useCopyFeedback(durationMs = 1600) {
  const copied = ref(false);
  let timer = null;

  async function copy(text) {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      return false;
    }
    copied.value = true;
    clearTimeout(timer);
    timer = setTimeout(() => (copied.value = false), durationMs);
    return true;
  }

  onBeforeUnmount(() => clearTimeout(timer));

  return { copied, copy };
}
